import { toast } from '@systemeio/ui'
import { useOpenNotificationMenuQuery } from 'modules/notifications/hooks/use-open-notification-menu-query'
import { useWaitedSharingIdsStorage } from 'modules/notifications/hooks/use-waited-sharing-ids-storage'
import { ShareLoco } from 'modules/share/constants/share-loco'
import { ShareResourceEnum } from 'modules/share/enum/share-resource-enum'
import { useShareResource } from 'modules/share/hooks/use-share-resource'
import { getSuccessMessage } from 'modules/share/utils/get-success-message'
import { NextPage } from 'next'
import Router, { useRouter } from 'next/router'
import { useEffect } from 'react'
import { Loader } from 'shared/components/loader'
import { SectionMessage } from 'shared/components/section-message'
import { useLocoTranslation } from 'shared/hooks/use-loco-translation'
import { getBaseServerSideProps } from 'shared/utils/get-base-server-side-props'

const Share: NextPage = () => {
  const { query } = useRouter()
  const { t } = useLocoTranslation()
  const { hash, type } = query as { hash?: string; type?: ShareResourceEnum }

  const { data, error } = useShareResource({ hash, type })

  const { addSharingId } = useWaitedSharingIdsStorage()

  useEffect(() => {
    if (!data) return

    if ('redirect_url' in data) {
      toast.success(getSuccessMessage(t, type))
      Router.replace(data.redirect_url)
    }

    if ('sharingId' in data) {
      toast.success(getSuccessMessage(t, type))
      addSharingId(data.sharingId)
      Router.replace(`/?${useOpenNotificationMenuQuery.queryToOpenNotificationMenu}`)
    }
  }, [data, type])

  return (
    // for now this page is used as a redirect page only
    <div className={'m-0 flex min-h-[80vh] items-center justify-center'}>
      {error ? (
        <SectionMessage>
          <div dangerouslySetInnerHTML={{ __html: error.message }} />
        </SectionMessage>
      ) : (
        <Loader />
      )}
    </div>
  )
}
export const getServerSideProps = getBaseServerSideProps(ShareLoco)

export default Share
